var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.449 14.988a.41.41 0 0 1-.308-.148.56.56 0 0 1 0-.71l5.792-6.686L.226.858a.56.56 0 0 1 0-.71.396.396 0 0 1 .615 0l6.015 6.94a.56.56 0 0 1 0 .71l-6.1 7.042a.41.41 0 0 1-.307.148Z",
    fill: "#000"
  })));
};

export default SvgArrowRight;